/*
 * Generated on 7/31/2026, 1:59:16 PM
 * Do not edit this file, any changes will be overwritten
 */

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var MarginTool = function MarginTool(text, locale) {
  var self = this;
  this.text = text;
  this.locale = locale;
  this.data = {
    abinbev: new MarginToolData(),
    competition: new MarginToolData()
  };
  Chart.defaults.font.family = 'Satoshi';
  Chart.defaults.color = "#000";
  Chart.defaults.font.size = 16;
  this.chart = new Chart(document.getElementById('chart'), {
    type: 'bar',
    data: {
      labels: ['', ''],
      datasets: [{
        label: this.text.Marge,
        data: [0, 0],
        backgroundColor: '#CAA44F'
      }, {
        label: this.text.Jaarlijkse_investering,
        data: [0, 0],
        backgroundColor: '#DEB741'
      }, {
        label: this.text.Bonus_Management,
        data: [0, 0],
        backgroundColor: '#C7C7C7'
      }]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        x: {
          stacked: true
        },
        y: {
          stacked: true,
          ticks: {
            callback: function callback(value) {
              return "€ " + value.toLocaleString(self.locale);
            }
          },
          afterFit: function afterFit(scale) {
            scale.width = 100;
          }
        }
      },
      plugins: {
        legend: {
          display: false
        },
        tooltip: {
          callbacks: {
            label: function label(context) {
              var label = context.dataset.label || '';

              if (label) {
                label = ' ' + label + ': ';
              }

              if (context.parsed.y !== null) {
                label += "€ " + context.parsed.y.toLocaleString(self.locale);
              }

              return label;
            }
          }
        }
      }
    }
  });
};

MarginTool.prototype.update = function (values) {
  $.each(this.data, function (key, data) {
    $.each(values[key], function (field, value) {
      data.setData(field, value);
    });
  });
  var data = this.getData();
  this.chart.data.labels[0] = data.abinbev.title + "  € " + data.abinbev.total.toLocaleString(this.locale);
  this.chart.data.labels[1] = data.competition.title + "  € " + data.competition.total.toLocaleString(this.locale);
  this.chart.data.datasets[0].data = [data.abinbev.margin, data.competition.margin];
  this.chart.data.datasets[1].data = [data.abinbev.investmentPerYear, data.competition.investmentPerYear];
  this.chart.data.datasets[2].data = [data.abinbev.bonusManagement, data.competition.bonusManagement];
  this.chart.update();
};

MarginTool.prototype.getDifference = function () {
  return this.data.abinbev.getData().total - this.data.competition.getData().total;
};

MarginTool.prototype.getData = function () {
  return {
    abinbev: this.data.abinbev.getData(),
    competition: this.data.competition.getData()
  };
};

var MarginToolData = function MarginToolData() {
  var _this = this;

  this.vatRate = .21;
  this.input = {
    volumeEstimationPilsner: null,
    volumeEstimationSpecialties: null,
    bonusManagementPilsner: null,
    bonusManagementSpecialties: null,
    standardGlassSizePilsner: 25,
    sellingPricePilsner: null,
    barrelOrTankContents: 50,
    purchasePriceBarrelOrTank: null,
    investmentPerYear: 0
  };

  this.isCompleted = function () {
    return Object.keys(_this.input).every(function (field) {
      return null !== _this.input[field];
    });
  };

  this.bonusManagement = function () {
    return _this.input.volumeEstimationPilsner * _this.input.bonusManagementPilsner + _this.input.volumeEstimationSpecialties * _this.input.bonusManagementSpecialties;
  };

  this.totalMargin = function () {
    return _this.margin() + _this.bonusManagement() + _this.input.investmentPerYear;
  };

  this.margin = function () {
    return Math.floor(_this.salesMarginPerHl() * (_this.input.volumeEstimationPilsner + _this.input.volumeEstimationSpecialties));
  };

  this.standardGlassSizeInLiters = function () {
    return _this.input.standardGlassSizePilsner / 100;
  };

  this.ptcInEuroPerConsumption = function () {
    return _this.input.sellingPricePilsner;
  };

  this.ptcInEuroPerHl = function () {
    return _this.ptcInEuroPerConsumption() / (_this.standardGlassSizeInLiters() / 100);
  };

  this.netPtcInEuroPerHl = function () {
    return _this.ptcInEuroPerHl() / (1 + _this.vatRate);
  };

  this.netPriceToPOCIncludingTaxesPerConsumption = function () {
    return _this.input.purchasePriceBarrelOrTank * (_this.standardGlassSizeInLiters() / _this.input.barrelOrTankContents * .9);
  };

  this.netPriceToPOCIncludingTaxesPerHl = function () {
    return _this.netPriceToPOCIncludingTaxesPerConsumption() / _this.standardGlassSizeInLiters() * 100;
  };

  this.salesMarginPerHl = function () {
    return _this.netPtcInEuroPerHl() - _this.netPriceToPOCIncludingTaxesPerHl();
  };
};

MarginToolData.prototype.setData = function (field, value) {
  if (field === 'title') {
    this.title = value;
    return;
  }

  if (typeof this.input[field] !== 'undefined' && !isNaN(parseFloat(value))) {
    this.input[field] = parseFloat(value);
  }
};

MarginToolData.prototype.getData = function () {
  return {
    title: this.title,
    margin: Math.floor(this.margin()),
    investmentPerYear: Math.floor(this.input.investmentPerYear),
    bonusManagement: Math.floor(this.bonusManagement()),
    total: this.totalMargin(),
    isCompleted: this.isCompleted()
  };
};

var ConsumerPriceTool = function ConsumerPriceTool(text) {
  var _this2 = this;

  this.text = text;
  this.groups = [];
  this.events = [];
  this.updateChartTimeout = false;
  this.settings = {
    x3: 3
  };
  this.on('change', function () {
    if (_this2.updateChartTimeout) {
      clearTimeout(_this2.updateChartTimeout);
    }

    _this2.updateChartTimeout = setTimeout(function () {
      _this2.updateChart();
    }, 50);
  });
};

ConsumerPriceTool.prototype.getGroups = function () {
  return this.groups;
};

ConsumerPriceTool.prototype.getGroup = function (groupKey) {
  return this.groups[groupKey];
};

ConsumerPriceTool.prototype.getMax = function (property) {
  var values = [];
  $.each(this.groups, function (groupKey, group) {
    values[groupKey] = group.getProperty(property);
  });
  return Math.max.apply(Math, values);
};

ConsumerPriceTool.prototype.getMaxGroupKey = function () {
  return Math.max.apply(Math, _toConsumableArray(this.groups.keys()));
};

ConsumerPriceTool.prototype.getNextGroupKey = function () {
  return this.getMaxGroupKey() + 1;
};

ConsumerPriceTool.prototype.deleteGroup = function (groupKey) {
  this.groups.splice(groupKey, 1);
  this.trigger('change');
};

ConsumerPriceTool.prototype.update = function (groupKey, values) {
  var group = this.groups[groupKey];

  if (!group) {
    group = new ConsumerPriceToolData(groupKey, this);
    this.groups[groupKey] = group;
  }

  $.each(values, function (field, value) {
    group.setData(field, value);
  });
  this.trigger('change');
};

ConsumerPriceTool.prototype.updateChart = function () {
  var property = 'MarginPerHL';
  var max = this.getMax(property) * 1;
  $.each(this.groups, function (groupKey, group) {
    var value = group.getProperty(property);
    var perc = 100 / max * value;
    $('.consumerpricetool .chart-bar[data-group="' + groupKey + '"] span').css('width', perc + '%');
  });
};

ConsumerPriceTool.prototype.updateSetting = function (setting, value) {
  this.settings[setting] = value;
  this.trigger('change');
};

ConsumerPriceTool.prototype.getSettings = function () {
  return this.settings;
};

ConsumerPriceTool.prototype.getData = function () {
  var data = [];
  $.each(this.groups, function (groupKey, group) {
    data[groupKey] = group.getData();
  });
  return data;
};

ConsumerPriceTool.prototype.on = function (event, callback) {
  this.events.push({
    event: event,
    callback: callback
  });
};

ConsumerPriceTool.prototype.trigger = function (event, data) {
  $.each(this.events, function (key, eventSettings) {
    if (eventSettings.event !== event) return;
    eventSettings.callback(data);
  });
};

var ConsumerPriceToolData = function ConsumerPriceToolData(key, tool) {
  var _this3 = this;

  this.key = key;
  this.tool = tool;
  this.vatRate = .21;
  this.input = {
    Title: '',
    PricePerKeg: 0,
    VolumePerGlassCL: 25,
    VolumePerKegL: 50,
    CurrentConsumerPrice: 0,
    BonusManagement: 0,
    EstimatedVolumeHL: 0
  };
  this.calculated = {
    PricePerL: function PricePerL() {
      return _this3.input.PricePerKeg / _this3.input.VolumePerKegL;
    },
    AveragePurchaseConsumerPrice: function AveragePurchaseConsumerPrice() {
      return _this3.calculated.PricePerL() / 100 * _this3.input.VolumePerGlassCL;
    },
    ConsumerPriceExVat: function ConsumerPriceExVat() {
      return _this3.input.CurrentConsumerPrice / (1 + _this3.vatRate);
    },
    AverageMarginPerConsumption: function AverageMarginPerConsumption() {
      return _this3.calculated.ConsumerPriceExVat() - _this3.calculated.AveragePurchaseConsumerPrice();
    },
    GrossMarginPercentage: function GrossMarginPercentage() {
      return _this3.calculated.ConsumerPriceExVat() === 0 ? 0 : _this3.calculated.AverageMarginPerConsumption() / _this3.calculated.ConsumerPriceExVat() * 100;
    },
    IndexPrice: function IndexPrice() {
      return _this3.key === 0 ? 100 : 100 / _this3.tool.getGroup(0).getData().PricePerL * _this3.calculated.PricePerL();
    },
    AveragePurchaseConsumerPriceX3: function AveragePurchaseConsumerPriceX3() {
      return _this3.calculated.AveragePurchaseConsumerPrice() * _this3.tool.settings.x3;
    },
    AveragePurchaseConsumerPriceIncVatX3: function AveragePurchaseConsumerPriceIncVatX3() {
      return _this3.calculated.AveragePurchaseConsumerPriceX3() * (1 + _this3.vatRate);
    },
    AverageMarginX3: function AverageMarginX3() {
      return _this3.calculated.AveragePurchaseConsumerPriceX3() / (1 + _this3.vatRate) - _this3.calculated.AveragePurchaseConsumerPrice();
    },
    GrossMarginX3: function GrossMarginX3() {
      return (_this3.calculated.AveragePurchaseConsumerPriceX3() - _this3.calculated.AveragePurchaseConsumerPrice()) / _this3.calculated.AveragePurchaseConsumerPriceX3() * 100;
    },
    MarginPerHL: function MarginPerHL() {
      return _this3.calculated.AverageMarginPerConsumption() / _this3.input.VolumePerGlassCL * 100 * 100 + _this3.input.BonusManagement;
    },
    Margin: function Margin() {
      return _this3.calculated.MarginPerHL() * _this3.input.EstimatedVolumeHL;
    }
  };
};

ConsumerPriceToolData.prototype.setData = function (field, value) {
  var type = _typeof(this.input[field]);

  if (type === 'undefined') {
    return;
  }

  if (type === 'number') {
    value = parseNumber(value);
  }

  this.input[field] = value;
};

ConsumerPriceToolData.prototype.getProperty = function (property) {
  if (this.input[property]) {
    return this.input[property];
  }

  if (this.calculated[property]) {
    return this.calculated[property]();
  }

  return null;
};

ConsumerPriceToolData.prototype.getData = function () {
  var data = this.input;

  for (var property in this.calculated) {
    data[property] = this.calculated[property]();
  }

  return data;
};